import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import firebase from "firebase"
import * as serviceWorker from './serviceWorker';
import routes from 'routes';
import { Router } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import amplitude from "amplitude-js"

const firebaseConfig = {
  apiKey: "AIzaSyD1hei_PMMoNrFcRJ19TyjfWWaa-8McQw8",
  authDomain: "beastdrop.firebaseapp.com",
  databaseURL: "https://beastdrop.firebaseio.com",
  projectId: "beastdrop",
  storageBucket: "beastdrop.appspot.com",
  messagingSenderId: "209410367191",
  appId: "1:209410367191:web:14dce6f67c5259e0725a92",
  measurementId: "G-BH2KQ5NCVM",
}
firebase.initializeApp(firebaseConfig)

amplitude.getInstance().init("8d52c2f65d5add79aae212a3a61eb396");

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <App>
        {routes}
      </App>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
